import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { FacadeService } from '../services/facade.service';

@Injectable({
	providedIn: 'root'
})
export class HasVehicleAccessGuard {
	private hasVehicleAccess = false;
	constructor(private facade: FacadeService, private router: Router) {}
	canActivate(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		this.hasVehicleAccess = this.facade.dataStorageService.isVehiculeActive();
		if (this.hasVehicleAccess) {
			return true;
		} else {
			this.router.navigate(['dashboard']);
			return false;
		}
	}
}
